import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import whileAwayBg from "@/assets/image/whileAwayBg.svg";
import { formatMoney } from "@/helpers/formatMoney";

export type AwayInfo = {
  duration: string;
  amount: number;
  earnedUsd: number;
};

const MoonIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const formatAwayAmount = (value: number): string => `+${formatMoney(value)}`;

const styles = {
  card: {
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    borderRadius: "12px",
    border: "2px solid #75B1FF",
    background: "linear-gradient(90deg, #2A85FF 0%, #1D9BF0 100%)",
    overflow: "hidden",
    padding: "14px 10px",
  },
  bg: {
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${whileAwayBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    filter: "blur(2px)",
    pointerEvents: "none",
    userSelect: "none",
  },
  pill: {
    backgroundColor: "#fff",
    border: "1px solid #BFDBFE",
    borderRadius: "20px",
    padding: "3px 10px",
  },
} as const;

const WhileYouWereAway: FC<{ info: AwayInfo }> = ({ info }) => {
  return (
    <Box sx={styles.card}>
      <Box sx={styles.bg} />

      <Stack sx={{ position: "relative", gap: "20px" }}>
        <Stack direction="row" alignItems="center" gap="6px">
          <MoonIcon />
          <Typography
            sx={{
              flex: 1,
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "16px",
              color: "#fff",
            }}
          >
            While you were away
          </Typography>
          <Box sx={styles.pill}>
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontWeight: 700,
                fontSize: "11px",
                lineHeight: "normal",
                color: "#2A85FF",
                whiteSpace: "nowrap",
              }}
            >
              {info.duration}
            </Typography>
          </Box>
        </Stack>

        <Stack gap="6px">
          <Stack direction="row" alignItems="baseline" gap="4px" sx={{ pt: "7px" }}>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 700,
                fontSize: "38px",
                lineHeight: "48px",
                letterSpacing: "-1.5px",
                color: "#fff",
              }}
            >
              {formatAwayAmount(info.amount)}
            </Typography>
            <Typography
              sx={{ fontFamily: "Inter", fontWeight: 700, fontSize: "15px", color: "#fff" }}
            >
              USDC
            </Typography>
          </Stack>
          <Typography sx={{ fontSize: "14px", color: "#fff" }}>
            <Box component="span" sx={{ fontFamily: "Inter", fontWeight: 700 }}>
              ≈ ${formatMoney(info.earnedUsd)}{" "}
            </Box>
            <Box component="span" sx={{ fontFamily: "Inter", fontWeight: 500 }}>
              earned while you were away
            </Box>
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default WhileYouWereAway;
